import React, {useEffect} from 'react';
import {connect} from "react-redux";
import {ErrorPage} from "app/Components/Block/SimReplacementBlock/steps/ErrorPage";
import SimReplacementStep from "app/Components/Block/SimReplacementBlock/steps/SimReplacementStep";
import {hideAppLoader, showAppLoader} from "app/Components/Shared/Loader/LoaderSlice";
import {
    setCurrentStep,
    setSubscriber,
    getSubscribers,
    simReplacementInit,
    handleSetError,
    simNumberAvailabilityCheck,
    replaceSim,
    steps,
    setBlockId,
    resetState
} from "./simReplacementSlice"
import Loader from "app/Components/Shared/Loader/Loader";
import {SuccessPage} from "app/Components/Block/SimReplacementBlock/steps/SuccessPage";
import SelectSubscriber from "app/Components/Block/SimReplacementBlock/steps/SelectSubscriber";
import OtpStep from "app/Components/Block/SimReplacementBlock/steps/OtpStep";


const SimReplacement = (props) => {
  console.log(props);
  useEffect(() => {
    if (props.userData?.isAuthenticateFinish) {
         if (!props.userData.loginData.isFullAuthenticated && !props.userData.loginData.isOtpAuthenticated && !props.userData.loginData.isOtpExtendedAuthenticated) {
           props.setCurrentStep(steps.OTP)
         } else {
           props.getSubscribers();
         }
    }
  }, [props.userData.isAuthenticateFinish]);

    useEffect(() => {
        props.setBlockId(props.iContent.contentLink.id);

        return () => {
            props.resetState();
        };
    }, [])

    useEffect(() => {
      if (props.simReplacementState.subscriber && props.simReplacementState.currentStep !== steps.SubscriberSelect) {
            props.simReplacementInit();
        }
    }, [props.simReplacementState.subscriber]);



    function renderStep() {
      window.scrollTo(0, 0);
        switch (props.simReplacementState?.currentStep) {
            case steps.Init:
                return <Loader/>
            case steps.OTP:
                return <OtpStep props={props}/>
            case steps.SubscriberSelect:
              return <SelectSubscriber/>
            case steps.SimReplacement:
                return <SimReplacementStep iContent={props.iContent}/>;
            case steps.Success:
                return <SuccessPage subscriber={props.simReplacementState?.subscriber}/>;
            case steps.Error:
                return <ErrorPage props={props}/>
        }
    }

    return (
        <div className='sim-replacement-main-container'>
            {renderStep(props.simReplacementState?.currentStep)}
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        simReplacementState: state.SimReplacement,
        userData: state.authentication
    }
};

const mapDispatchToProps = {
    setSubscriber,
    getSubscribers,
    simReplacementInit,
    setCurrentStep,
    showAppLoader,
    hideAppLoader,
    handleSetError,
    simNumberAvailabilityCheck,
    replaceSim,
    setBlockId,
    resetState
};

export default connect(mapStateToProps, mapDispatchToProps)(SimReplacement);
